import jsonpack from 'jsonpack';

/** Twin of `GZIP_BODY_PREFIX` in `server/api/src/utils/responseBody.ts`. */
export const GZIP_BODY_PREFIX = 'gz64:';

/**
 * Decodes a `/gql` response body. Large bodies arrive as `gz64:` +
 * base64(gzip(JSON)) — jsonpack is quadratic and timed out on big image
 * layers — the rest as plain JSON (errors) or jsonpack.
 */
export async function decodeResponseBody(body: string): Promise<any> {
  if (body.startsWith(GZIP_BODY_PREFIX)) {
    const bytes = Uint8Array.from(atob(body.slice(GZIP_BODY_PREFIX.length)), (c) => c.charCodeAt(0));
    const stream = new Response(bytes).body!.pipeThrough(new DecompressionStream('gzip'));
    return JSON.parse(await new Response(stream).text());
  }
  try {
    return JSON.parse(body);
  } catch {
    return jsonpack.unpack(body);
  }
}
